// extracted by mini-css-extract-plugin
export default {"cls1":"jk1MBBUxbNlGxEFoCqbP","cls2":"UeyBRVF80XgD2tu3lElJ jk1MBBUxbNlGxEFoCqbP"};